import React, { useEffect } from "react";
import BaseLayout from "layouts/base-layout";
import { useDispatch, useSelector } from "react-redux";
import BackgroundImage from "components/background-image";
import { TOGGLE_SUBS_CART } from "utils/action-types";
import clsx from "clsx/lite";
import { listPaymentMethods } from "actions/account/subscription";


const AccountProfileLayout = ({ children, path, header, footer, headerImage, pageSettings }) => {
	const { draftChanges, paymentMethods, isFetched } = useSelector(
		(state) => state.account.subscription
	);
	const dispatch = useDispatch();

	useEffect(() => {
		if (draftChanges.unsaved) {
			setTimeout(() => {
				dispatch({ type: TOGGLE_SUBS_CART });
			}, 1000);
		}
	}, []);

	useEffect(() => {
		if (!paymentMethods.length)
			dispatch(listPaymentMethods());
	}, []);

	return (
		<BaseLayout
			path={path}
			header={header}
			footer={footer}
			pageSettings={pageSettings}>
			<div className={clsx("flex w-full mx-auto hd-screen-max-width", headerImage ? "mt-2" : "lg:mt-16 mt-8")}>
				<div className="flex flex-col overflow-hidden w-full">
					<div className="w-full lg:w-90 mx-auto lg:px-0 px-5">
						{headerImage && isFetched && <BackgroundImage data={headerImage} />}
					</div>
					{children}
				</div>
			</div>
		</BaseLayout>
	);
};

export default AccountProfileLayout;
